import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IAppConfig } from "../lib/config/app-config";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { OrganisationPermissionsLabelDto } from "../_models/Organisation";

@Injectable({
  providedIn: "root",
})
export class OrganisationPermissionService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "OrganisationPermission/";
  private static readonly GETPERMISIONS_URI: string = "getpermissions";
  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public getOrganisationPermissions$(): Observable<
    OrganisationPermissionsLabelDto[]
  > {
    return this.http.get<OrganisationPermissionsLabelDto[]>(
      this.baseUrl +
        OrganisationPermissionService.path +
        OrganisationPermissionService.GETPERMISIONS_URI
    );
  }
}
